import axios from '../../axios'

// 新增专业级投档预估分
export const addProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity',
        method: 'POST',
        data
    })
}

// 修改专业级投档预估分信息
export const eidtProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity',
        method: 'PUT',
        data
    })
}

// 删除专业级投档预估分信息
export const deleteProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索专业级投档预估分信息列表
export const getProfPredictList = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity',
        method: 'GET',
        data
    })
}

// 获取专业级投档预估分详情
export const getProfPredictInfo = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity/info',
        method: 'GET',
        data
    })
}

// 专业级投档预估分数据导入
export const importProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity/import',
        method: 'POST',
        data
    })
}

// 专业级投档预估分数据导出
export const exportProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity/export',
        method: 'POST',
        data
    })
}

// 专业级投档预估分数据批量更新
export const updateProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity/batch/update',
        method: 'POST',
        data
    })
}

// 专业级投档预估分数据对比导出
export const diffExportProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity/diff/export',
        method: 'POST',
        data
    })
}

// 专业级投档预估分数据批量删除
export const queryDelProfPredict = (data) => {
    return axios({
        url: '/api/data/wish/admission/parity/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/profpredict.js